import { Component, Input } from '@angular/core';
import { AuditTrialDetails } from '../../models/audits/audit-trial-details';

@Component({
  selector: 'app-audit-item-details',
  templateUrl: './audit-item-details.component.html',
  styleUrls: ['./audit-item-details.component.scss']
})
export class AuditAttributeDetailsComponent {
  @Input() auditTrialDetails! : AuditTrialDetails;
  timeZoneFormat:string= "(UTC)";
}
